import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const AiprizeRegistrationRecordSchema = z
    .object({
        name: z.string().nullable().optional(),
        recordId: z.string().nullable().optional(),
        entityType: z.string().nullable().optional(),
        status: z.string().nullable().optional(),
        registrationDate: z.union([z.string(), z.date()]).nullable().optional(),
        city: z.string().nullable().optional(),
        state: z.string().nullable().optional(),
        country: z.string().nullable().optional(),
        source_url: z.string().nullable().optional(),
        source_name: z.string().nullable().optional(),
        addresses: z.array(z.string().nullish()).optional(),
    })
    .strict();

export class AiprizeRegistrationRecord extends FromSchema(AiprizeRegistrationRecordSchema) {
    name?: string | null;
    recordId?: string | null;
    entityType?: string | null;
    status?: string | null;
    registrationDate?: string | Date | null;
    city?: string | null;
    state?: string | null;
    country?: string | null;
    source_url?: string | null;
    source_name?: string | null;
    addresses?: string[];
}
